import store from "../redux/store";
import Socket from "./socket";
import {
  setRoom,
  endGame,
  show_leave_game,
  setSession,
  setGameName,
  setSliceGameCode,
} from "../redux/game/action";
import { get_route_from_game_code } from "shared/helpers/get_route_from_game_code";
const LEAVE_MESSAGES = [
  "You have been kicked",
  "Host has ended the session.",
  "Goodbye",
];
const SOCKET_LEAVE_MESSAGES = [
  "You left the session",
  "You have been kicked from the session",
];

export const onMessageGetEventErrorAndData = (message) => {
  const parsedMessage = JSON.parse(message.data);
  const event = onMessageGetEvent(parsedMessage);
  const error = onMessageGetError(parsedMessage);
  const data = onMessageGetData(parsedMessage);
  return { event, error, data };
};

export const doObviousOnMessageActions = (event, data) => {
  switch (event) {
    case "ping":
      onPingActions(data);
      break;
    case "end-game":
      onEndGameActions(data);
      break;
    default:
      break;
  }
  if (data?.room?.id) {
    if (data.room.active_game) {
      store.dispatch(setRoom(data));

      if (get_route_from_game_code(data.room.game_code) === "slice") {
        store.dispatch(endGame());
        store.dispatch(setSliceGameCode(data.room.branch_url));
      } else {
        store.dispatch(setGameName(data.room.game_code));
        store.dispatch(setSliceGameCode(""));
      }
    } else {
      store.dispatch(show_leave_game(true));
      store.dispatch(endGame());
      store.dispatch(setSliceGameCode(""));
    }
  }
  if (data?.session) {
    if (data?.session?.valid) {
      store.dispatch(setSession(data.session));
    } else {
      store.dispatch(setSession({}));
    }
  }
};

const onPingActions = () => {
  const storeState = store.getStore().getState();
  const room = storeState?.gameReducer?.roomObj;
  if (Object.keys(room).length > 0 && room?.active_game) {
    const data = {
      action: "get-room",
      joinCode: room.join_code,
    };
    Socket.sendMessage(data);
  }
};

const onEndGameActions = () => {
  store.dispatch(show_leave_game(true));
  store.dispatch(endGame());
};

const onMessageGetEvent = (response) => {
  if (response?.message === "PONG") {
    return "ping";
  }
  if (response.message && LEAVE_MESSAGES.includes(response.message)) {
    return "end-game";
  }
  if (response.message && SOCKET_LEAVE_MESSAGES.includes(response.message)) {
    return "session-leave";
  }
  if (response.message === "Scored" || response.message === "Skipped") {
    return "tot-skipped-scored";
  }
  if (response?.action) {
    return response?.action;
  }
  if (response?.event) {
    return response?.event;
  }
  return "others";
};

const onMessageGetError = (response) => {
  return response.error;
};

const onMessageGetData = (response) => {
  return response;
};
